export default __webpack_public_path__ + "static/media/IcBell.b70656b7.svg";